// extracted by mini-css-extract-plugin
export var active = "_90-7";
export var container = "_90-0";
export var evenWidth = "_90-4";
export var large = "_90-5";
export var outlet = "_90-8";
export var slide = "_90-2";
export var small = "_90-6";
export var tab = "_90-3";
export var tabs = "_90-1";